import type { OffsiteConfig } from "@/engine/app/offsite-config";
import { SLIDE_COMPONENTS } from "./deck";
import "./tokens.css";

export const config: OffsiteConfig = {
  id: "ar",
  displayName: "KI-Session Gremien",
  subdomain: "ki.svo-gremien.de",
  apiBaseUrl: "https://api.ki.svo-gremien.de",
  deck: SLIDE_COMPONENTS,
  progressCuts: [],
  // Vier Phasen. Kein topics/voting/grouping (Solo-Teams), kein
  // evaluating/evaluated (die Bewertung kostet Sitzungszeit ohne Nutzen).
  phases: ["intro", "working", "overnight", "reveal"],
  soloTeams: true,
  formal: true,
  wordmark: "SVO · GREMIEN",
  requirementFields: [
    {
      key: "thema",
      label: "Woran möchten Sie arbeiten?",
      placeholder: "z. B. Rechnung vom Energieversorger erklärt",
      prefillFromFraming: true,
      // Mehrzeilig, obwohl es nur ein Satz ist: Das Feld kommt mit dem
      // Rahmenthema vorbelegt, und in einem einzeiligen Eingabefeld waren auf
      // dem Handy nur die ersten drei, vier Wörter zu sehen. Wer den Text nicht
      // lesen kann, kann ihn auch nicht sinnvoll ändern.
      multiline: true,
    },
    {
      key: "was",
      // Nicht „das Ding": Das Gremium beschreibt hier eine Anwendung für die
      // Verwaltung, keine Bastelei.
      label: "Was soll die Anwendung können?",
      placeholder: "Beschreiben Sie in ein, zwei Sätzen, was sie tun soll.",
      multiline: true,
    },
    {
      key: "anforderungen",
      label: "Worauf kommt es Ihnen besonders an?",
      placeholder: "Was wäre für Sie das Wichtigste daran?",
      multiline: true,
    },
  ],
  ai: { evalPromptKey: "ar", overnightPromptKey: "ar" },
  // Vorbereitete Themen: einmal hier, gelesen von der Themen-Folie und vom
  // Moderatorpult.
  preparedTopics: [
    {
      short: "Rechnung erklärt",
      full: "Rechnung vom Energieversorger erklärt",
    },
    {
      // Bewusst ohne „OCR" — vor dem Gremium keine Fachbegriffe.
      short: "Formular auslesen",
      full: "Papierformular abfotografieren und automatisch auslesen",
    },
  ],
  // 0-basierte Slide-Indizes (siehe engine/app/offsite-config.ts), Reihenfolge
  // siehe deck.ts. Index 2 ist die Themenwahl, Index 3 die Prompten-Folie mit
  // Adresse, PIN und QR-Code.
  // Titel und Einführung werden von Hand angefahren; ab der Zugangs-Folie führt
  // die Moderationsleiste. Vorher konnte man mit der Folien-Navigation auf eine
  // Folie blättern, die zu keinem Ablauf-Schritt gehörte — dann sprang die
  // Leiste nicht mit, und der Timer war nicht erreichbar.
  // Der Exkurs zwischen Generierung und Ergebnissen: die Plattform zeigen,
  // während die KI baut. Neuer Tab — die Sitzung bleibt im ersten stehen.
  //
  // dev.svoos.de ist kein Provisorium: SVO OS hat kein Produktionssystem, und
  // Dev ist das weiteste in allen Belangen — Software, Daten, Funktionsumfang.
  // Es ist damit auch vor einem Gremium das Richtige zum Zeigen.
  exkurs: { label: "SVO OS", url: "https://dev.svoos.de" },
  introSlides: 2,
  // Zugang (Adresse, PIN, QR) — steht, während die Gäste sich anmelden.
  waitingSlide: 2,
  // Themenwahl — die Runde entscheidet.
  themaSlide: 3,
  // Arbeitsphase — sobald die Uhr läuft, zählt die Zeit, nicht der QR-Code.
  workingSlide: 4,
  // Generierung — bleibt stehen, während der Moderator daneben SVO OS zeigt.
  overnightAnnouncementSlide: 5,
  overnightWaitLabel: "Die KI baut Ihren Prototyp – gleich auf der Leinwand.",
  // Nur beim Reveal übernimmt die Workshop-Oberfläche die Leinwand. Während
  // des Promptens bleibt die Folie mit QR-Code und PIN stehen — Nachzügler
  // finden so noch herein, und niemand sieht die Moderator-Bedienung.
  workshopOverlayPhases: ["reveal"],
};
